export interface PickOption {
  value: string
  label: string
  /** A quiet second line: a code, or why it cannot be picked. */
  note?: string
  disabled?: boolean
}

/** The options whose label or note contains every word of the query, case-insensitively. */
export function filterOptions<T extends PickOption>(options: readonly T[], query: string): T[] {
  const words = query.toLocaleLowerCase().split(/\s+/).filter(Boolean)
  if (words.length === 0) return [...options]
  return options.filter((o) => {
    const text = `${o.label} ${o.note ?? ''}`.toLocaleLowerCase()
    return words.every((w) => text.includes(w))
  })
}

/** The selection after pressing an option: added or removed; a disabled option never changes it. */
export function toggleValue(selected: readonly string[], option: PickOption): string[] {
  if (selected.includes(option.value)) return selected.filter((v) => v !== option.value)
  if (option.disabled) return [...selected]
  return [...selected, option.value]
}
